import { useContext } from 'react';
import { AppContext, usePermission } from '@ctsu/loader';
import { useSelector } from 'react-redux';

export const CanUserHasGroup = () => {
  const leadGrp = useSelector((state) => state.prtDetails.prtInfo.leadGrp);
  const context = useContext(AppContext);
  const { userGroups } = context && context.session;
  return userGroups && (userGroups.includes('CTSU') || userGroups.includes(leadGrp));
};

export const CanUserViewSection = (per) => usePermission(per);

// RDIMS
export const CanUserViewRDIMSBrowser = () => usePermission('regulatory.rdims.browser');
export const CanUserFilterRDIMSBrowser = () => usePermission('regulatory.rdims.filters');

export const CanUserViewFaxIds = () => usePermission('regulatory.rdims.faxid.view');
export const CanUserUnlockRecord = () => usePermission('regulatory.rdims.unlock');
export const CanUserDeleteRecord = () => usePermission('regulatory.rdims.delete');

export const CanUserEditSubmission = () => usePermission('regulatory.rdims.submission.edit');
export const CanUserCreatePacket = () => usePermission('regulatory.rdims.packet.create');

// SiteRegistrationBrowser

export const CanUserViewSiteRegBrowser = () => usePermission('regulatory.sitereg.browser');
export const CanUserFilterSiteRegBrowser = () => usePermission('regulatory.sitereg.filters');

export const CanUserViewSiteRegExcel = () => usePermission('regulatory.sitereg.browser.excel');
export const CanUserViewTxAll = () => usePermission('regulatory.sitereg.browser.transactions');
export const CanUserViewRefresh = () => usePermission('regulatory.sitereg.browser.refresh');

export const CanUserViewIbutton = () => usePermission('regulatory.sitereg.ibutton');
export const CanUserViewTxbutton = () => usePermission('regulatory.sitereg.tx');
export const CanUserViewGobutton = () => usePermission('regulatory.sitereg.go');

// IRB Browser // not added indicates - in the API
export const CanUserViewIRBBrowser = () => usePermission('regulatory.irb.browser');
export const CanUserFilterIRBBrowser = () => usePermission('regulatory.irb.browser.filters'); // not added
export const CanUserViewIRBExcel = () => usePermission('regulatory.irb.browser.excel'); // not added
export const CanUserViewIRBGobutton = () => usePermission('regulatory.irb.browser.go');
export const CanUserViewIRBDeleteButton = () => usePermission('regulatory.irb.delete');
export const CanUserViewIRBRefreshbutton = () => usePermission('regulatory.irb.refresh'); // not added
export const CanUserViewAag = () => usePermission('regulatory.irb.aag'); // not added
export const CanUserSeeIRBView = () => usePermission('regulatory.irb.view'); // not added
export const CanUserEditIRB = () => usePermission('regulatory.irb.edit');
export const CanUserAddSiteIRB = () => usePermission('regulatory.irb.addsite'); // not added
export const CanUserAddProtocolIRB = () => usePermission('regulatory.irb.addprotocol');
export const CanUserAddTypeIRB = () => usePermission('regulatory.irb.apptype');
export const CanUserEditPIIRB = () => usePermission('regulatory.irb.editPI');
export const CanUserDeletePIIRB = () => usePermission('regulatory.irb.delete'); // not added
export const CanUserViewIRBHistory = () => usePermission('regulatory.irb.history'); // not added
export const CanUserViewIRBSiteReg = () => usePermission('regulatory.irb.sitereg'); // not added
export const CanUserViewIRBPkt = () => usePermission('regulatory.irb.pkt'); // not added
export const CanUserViewIRBPktHistory = () => usePermission('regulatory.irb.pkthistory'); // not added

// CAP
export const CanUserFilterCAPBrowser = () => usePermission('regulatory.cap.filters');
export const CanUserSortAprlDate = () => usePermission('regulatory.cap.sort.date');
export const CanUserEditCAPBrowser = () => usePermission('regulatory.cap.event.edit');

// Packet Browser
export const CanUserLockRecord = () => usePermission('regulatory.packets.browser.lock');
export const CanViewExternalFilters = () => usePermission('regulatory.packets.filter');
export const CanUserViewIndex = () => usePermission('regulatory.packets.browser.index');
export const CanUserEditIndex = () => usePermission('regulatory.packets.browser.index.edit');
export const CanUserCreateSR = () => usePermission('regulatory.packets.browser.sr.create');
export const CanUserCopyPacket = () => usePermission('regulatory.packets.browser.copy');
export const CanUserViewDetails = () => usePermission('regulatory.packets.browser.details');
export const CanUserEditDetails = () => usePermission('regulatory.packets.browser.details.edit');
export const CanUserSeeSupportingDocs = () => usePermission('regulatory.packets.browser.supportingdocs');
export const CanUserUploadSupportingDocs = () => usePermission('regulatory.packets.browser.docs.upload');
export const CanUserSeeMainGridDocs = () => usePermission('regulatory.packets.browser.docs');
export const CanUserEditPacketComments = () => usePermission('regulatory.packets.browser.comments.edit');
export const CanUserCommunicate = () => usePermission('regulatory.packets.browser.communicate');
export const CanUserSeePacketStatus = () => usePermission('regulatory.packets.browser.tracking.status');
export const CanUserSeePacketHistory = () => usePermission('regulatory.packets.browser.status.history');

// Packet Browser External Filter
export const CanSeeMyLocks = () => usePermission('regulatory.packets.browser.mylocks');
export const CanSeeMyPackets = () => usePermission('regulatory.packets.browser.mypackets');
export const CanSeeNextPacket = () => usePermission('regulatory.packets.browser.next');
export const CanSeeRefresh = () => usePermission('regulatory.packets.browser.refresh');
export const CanSeeTon = () => usePermission('regulatory.packets.browser.ton');
export const CanSeeEntry = () => usePermission('regulatory.packets.browser.entry');
export const CanSeeIndexing = () => usePermission('regulatory.packets.browser.indexing');

// Packet Browser Indexing Buttons
export const CanSeeIndexingGo = () => usePermission('regulatory.packets.browser.index.go');
export const CanSeeIndexingHistory = () => usePermission('regulatory.packets.browser.index.history');
export const CanSeeIndexingIRB = () => usePermission('regulatory.packets.browser.index.irb');
export const CanSeeIndexingSR = () => usePermission('regulatory.packets.browser.index.sr');
export const CanSeeIndexingChangePI = () => usePermission('regulatory.packets.browser.index.changepi');

// Site Registration
export const CanSeeSRAAG = () => usePermission('regulatory.sitereg.aag');
export const CanSeeSRApply = () => usePermission('regulatory.sitereg.apply');
export const CanSeeSRDelete = () => usePermission('regulatory.sitereg.delete');
export const CanSeeSREdit = () => usePermission('regulatory.sitereg.edit');
export const CanSeeSRIrbHistory = () => usePermission('regulatory.sitereg.irbhistory');
export const CanSeeSRPktHistory = () => usePermission('regulatory.sitereg.pkthistory');
export const CanSeeSRPrefs = () => usePermission('regulatory.sitereg.prefs');
export const CanSeeSRPsr = () => usePermission('regulatory.sitereg.psr');
export const CanSeeSRRefresh = () => usePermission('regulatory.sitereg.refresh');
export const CanSeeSRPacket = () => usePermission('regulatory.sitereg.show');
export const CanSeeSRView = () => usePermission('regulatory.sitereg.view');
export const CanSeeSRWithdraw = () => usePermission('regulatory.sitereg.withdraw');

// Multi Network
export const CanSeeMultiNetworkAdd = () => usePermission('regulatory.multinetwork.add');
export const CanSeeMultiNetworkDelete = () => usePermission('regulatory.multinetwork.deactivate');

// list selection
export const CanSeeListSelectionMaintenanceEdit = () => usePermission('regulatory.listselection.edit');
export const CanSeeListSelectionMaintenanceAdd = () => usePermission('regulatory.listselection.add');

// cirb site prefs
export const CanSeeAdminCIRBPrefsEdit = () => usePermission('regulatory.cirbprefs.edit');
export const CanSeeAdminCIRBPrefsAdd = () => usePermission('regulatory.cirbprefs.add');
export const CanSeeAdminCIRBPrefsAddDetail = () => usePermission('regulatory.cirbprefs.adddetail');
export const CanDeactivateCIRBDetailStatus = () => usePermission('regulatory.cirbprefs.deactivatedetail');

// queue mapping
export const CanSeeQueueMappingEdit = () => usePermission('regulatory.queue.edit');
export const CanSeeQueueMappingAdd = () => usePermission('regulatory.queue.add');

// sub study
export const CanSeeSubStudyAdd = () => usePermission('regulatory.substudy.add');
export const CanSeeSubStudyDelete = () => usePermission('regulatory.substudy.deactivate');

// packet locks
export const CanSeeClearLocksButton = () => usePermission('regulatory.packetlocks.clear');

// email template view/manage
export const CanSeeEmailTemplate = () => usePermission('regulatory.emailtemplatesetup.view');
export const CanUserEditEmailTemplate = () => usePermission('regulatory.emailtemplatesetup.edit');
